/**
 * Resolves local cover asset paths for a project slug.
 *
 * Files live in /public/project-covers/<slug>/.
 * All paths are returned regardless of whether the files exist —
 * the caller handles 404 via onError callbacks.
 *
 * Priority consumed by ProjectCoverMedia:
 *   video  →  coverVideoUrl (DTO) → local cover.mp4
 *   image  →  coverImageUrl (DTO) → local cover.webp → local cover.jpg
 *   poster →  coverPosterUrl (DTO) → local poster.jpg
 */

export interface ProjectCoverAssets {
  videoUrl: string;
  posterUrl: string;
  webpUrl: string;
  jpgUrl: string;
}

export function getProjectCoverAssets(slug: string): ProjectCoverAssets {
  const base = `/project-covers/${encodeURIComponent(slug)}`;
  return {
    videoUrl: `${base}/cover.mp4`,
    posterUrl: `${base}/poster.jpg`,
    webpUrl: `${base}/cover.webp`,
    jpgUrl: `${base}/cover.jpg`,
  };
}
